import React, { useEffect } from 'react';
import residentialImg from "../img/envision/about/nature/circuit-sustainability-41a61j51yyxbvc9z.jpg";
import Aboutsustainablefirstsection from './Aboutsustainablefirstsection';
import AboutSustanbilitysecondsection from './AboutSustanbilitysecondsection';
import InnovationStudycases from './InnovationStudycases'
import AboutourServices from './AboutourServices';
import Aboutcommitments from './Aboutcommitments';
import AboutDevirsityCommitments from './AboutDevirsityCommitments';



const AboutusDiversityInclusion = () => {
       useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
         
    return (
        <section style={{  }}>
            <div className="container-fluid" style={{ padding: "0px", overflow: "hidden" }}>
                <div className="row">
                    <div className="col-lg-12">
                        <section
                            className="breadcumb"
                            aria-label="breadcumb"
                            style={{
                                backgroundImage: `url(${residentialImg})`,
                                height: "750px", // Increased height for image
                                backgroundSize: "cover", // Ensure the image covers the section
                                backgroundPosition: "center", // Center the image
                            }}
                        >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="main">
                                            <div className="bread">
                                                <div
                                                    className="bread-title"
                                                    style={{
                                                        fontSize: '2.5rem',
                                                        fontWeight: '700',
                                                        letterSpacing: '2px',
                                                        display: 'block',
                                                        marginTop:'100px'
                                                    }}
                                                >
                                                    DIVERSITY, EQUITY AND INCLUSION
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            {/* <Aboutcommitments /> */}
            <AboutDevirsityCommitments />
         
            <AboutourServices />
        </section>
    );
};

export default AboutusDiversityInclusion;
